import type { FaireProductEntity } from "../../entity_types/product";

export const p_67yf6fcvph: FaireProductEntity = {
  token: "p_67yf6fcvph",
  type: "product",
  name: "7.2oz. No. 4 Rosemary + Sage Candle",
  brandToken: "b_y6mta332qy",
  brandName: "Choice Blooms",
  imageUrl:
    "https://cdn.faire.com/fastly/8f06d566b8a9fef093cf83c7d1434b22bd7a41e1416ed9b5951c2718b7963f6d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3e26245d006423e598c17da9769f2a4127e652915e1b1d165e0acd0eb356472f.jpeg",
    "https://cdn.faire.com/fastly/85a874d06492abb85612f3eaa8f241749f6884a8460bbbd8e535bd57304a249e.jpeg",
    "https://cdn.faire.com/fastly/01695bb0eae85cbd841bd4f7f8cb19c50cdb79e9dae703d19fd0a69e9fb9767e.jpeg",
    "https://cdn.faire.com/fastly/9ab3f7b3b830e4eb058d596c36fdad34ebc1ae5bc90fa85878dc775fb62b45f4.jpeg",
    "https://cdn.faire.com/fastly/c6a1b2690291e7a31c1fc269bd29c7b235fcd6c423eb39cf917cd88630d76008.jpeg",
  ],
  priceDollars: 16,
  description:
    "THIS 7.2 oz SIZE WILL BE DISCONTINUED- AVAILABLE WHILE SUPPLIES LAST.\nThis glass is different-less candle, more glass, heavier + thicker from the other sizes- please consider this when mixing the sizes in your assortment.\n\nNo. 4: Rosemary + Sage \nMade with hemp coconut blend wax+burns with a hemp wick all in a groovy CLEAR glass vessel. \n*Each vessel is unique in shape that is out of our control. \n\n-7.2 oz. in an 8 oz vessel. 40-50 burn time hours \n\nThe Smell:No. 4: Rosemary + Sage- forest green, woodsy green.\nTop: Eucalyptus, Pine\nHeart: Rosemary, Green Floral \nBase: Sage, Cedar\n\nOur wax:A blend of natural hemp, soy, and coconut wax. This wax is clean-burning, biodegradable, + natural. Our wax is renewable + non-toxic. \n\nThe Wick: Made Of 100% Organic Hemp + 100% Beeswax. Little to no soot, non-toxic, and biodegradable. Contains NO lead, zinc, or other metals. Hemp wick burns slower than other wicks with a lower temperature flame and little to no smoke.",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:50.176Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
